import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function ViewEmailDetail() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2541">
      <div className="flex items-center justify-between" data-id="element-2542">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2543">Email Detail</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/email-details')} data-id="element-2544">
          ← Back to Email Details
        </Button>
      </div>

      <Card data-id="element-2545">
        <CardContent className="pt-6" data-id="element-2546">
          <table className="text-sm w-full" data-id="element-2547">
            <tbody data-id="element-2548">
              <tr className="border-b border-slate-100" data-id="element-2549">
                <td className="py-2 pr-6 font-medium text-slate-700 w-24 align-top" data-id="element-2550">
                  Id
                </td>
                <td className="py-2 text-slate-900" data-id="element-2551">1</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2552">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2553">
                  Subject
                </td>
                <td className="py-2 text-slate-900" data-id="element-2554">
                  Welcome to Desert Sage Seminars
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2555">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2556">
                  Body
                </td>
                <td className="py-4 text-slate-800 leading-relaxed max-w-2xl" data-id="element-2557">
                  <div className="space-y-3" data-id="element-2558">
                    <p data-id="element-2559">
                      You have received this notification from{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2560">
                        Desert Sage Seminars
                      </a>{' '}
                      because you are a registered user. You have successfully
                      registered with Desert Sage Seminars.{' '}
                      <span className="bg-yellow-200 font-bold" data-id="element-2561">
                        PLEASE SAVE THIS EMAIL FOR YOUR RECORDS.
                      </span>
                    </p>
                    <p data-id="element-2562">
                      Your Username and Password will enable you to enroll in
                      our courses at any time.
                    </p>
                    <p data-id="element-2563">Your Username is as follows:</p>
                    <table className="border border-slate-300 text-sm" data-id="element-2564">
                      <tbody data-id="element-2565">
                        <tr data-id="element-2566">
                          <td className="border border-slate-300 px-3 py-1 font-medium" data-id="element-2567">
                            Username:
                          </td>
                          <td className="border border-slate-300 px-3 py-1" data-id="element-2568">
                            username
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p data-id="element-2569">
                      Please remember that the Password you created is case
                      sensitive.
                    </p>
                    <p data-id="element-2570">You affirmed the following to be true:</p>
                    <ul className="list-disc pl-6 space-y-1 font-bold" data-id="element-2571">
                      <li data-id="element-2572">I will be the person taking these classes, and</li>
                      <li data-id="element-2573">
                        I realize that it is a felony to impersonate a real
                        estate licensee
                      </li>
                      <li data-id="element-2574">
                        I will not complete more than 9 renewal hours within the
                        same calendar day
                      </li>
                    </ul>
                    <p data-id="element-2575">
                      At any time while taking a course, you will be able to
                      contact Tech Support* should you encounter a problem with
                      our website, or Course Support* should you encounter any
                      issues with the course, the text, quizzes or anything
                      course related.
                    </p>
                    <p data-id="element-2576">
                      * Support will be available 7 days a week from 7:30 AM to
                      9:00 PM Arizona time.
                    </p>
                    <p data-id="element-2577">
                      Thank you for registering with Desert Sage Seminars. We
                      are sure you will find our courses to be an efficient and
                      valuable use of your time.
                    </p>
                    <p data-id="element-2578">Cordially</p>
                    <p className="font-bold" data-id="element-2579">
                      Jon Kichen, Instructor
                      <br data-id="element-2580" />
                      Owner/Administrator
                      <br data-id="element-2581" />
                      Desert Sage Seminars
                      <br data-id="element-2582" />
                      Phone: 602-377-6207
                      <br data-id="element-2583" />
                      URL: www.DesertSageSeminars.com
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2584">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2585">Param</td>
                <td className="py-2 text-slate-900 font-mono text-xs" data-id="element-2586">
                  sign_in_confirmation
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2587">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2588">
                  Created
                </td>
                <td className="py-2 text-slate-900" data-id="element-2589">2011-09-26 12:39:36</td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6 pt-4 border-t border-slate-200 space-y-1" data-id="element-2590">
            <p className="text-sm font-medium text-slate-700" data-id="element-2591">Actions</p>
            <div className="flex flex-col gap-1 text-sm text-blue-600" data-id="element-2592">
              <button className="text-left hover:underline w-fit" onClick={() => navigate('/email-details/edit/1')} data-id="element-2593">
                Edit Email Detail
              </button>
              <button className="text-left hover:underline text-red-500 w-fit" data-id="element-2594">
                Delete Email Detail
              </button>
              <button className="text-left hover:underline w-fit" onClick={() => navigate('/email-details')} data-id="element-2595">
                List Email Details
              </button>
              <button className="text-left hover:underline w-fit" data-id="element-2596">
                New Email Detail
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}